import Vue from "vue";
import Murmur from "@icij/murmur";
Vue.use(Murmur);
Murmur.config.set('project.name', 'Confidential Clients')
Murmur.config.set('app.name', 'Confidential Clients')
Murmur.config.set('app.home', 'https://www.icij.org/investigations/cyprus-confidential/oligarchs-offshore-clients')